import { useEffect, useState, useCallback } from 'react';

/**
 * Exécute un appel API et expose { data, loading, error, refetch }.
 * `deps` fonctionne comme le tableau de dépendances de useEffect.
 *
 * Exemple : const { data: services, loading } = useFetch(() => servicesApi.list(), []);
 */
export function useFetch(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);

    fetcher()
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refetch: load };
}
